import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AdminStore } from '../admin-service/admin-service.store';

@Component({
  selector: 'app-passwordPolicy',
  templateUrl: './passwordPolicy.component.html',
  styleUrls: ['./passwordPolicy.component.scss'],
})
export class passwordPolicyComponent implements OnInit {
  displayedColumns: string[] = ['text', 'value'];

  data: any[] = [];

  constructor(public translateService: TranslateService, private adminStore: AdminStore, private router: Router) {}

  ngOnInit(): void {
    this.adminStore.getPasswordPolicies().then(
      (data) => {
        console.log(data);
        this.data = [
          { text: this.translateService.instant('passwordPolicy.PIN'), value: data.pinQuantityNoRepeat },
          { text: this.translateService.instant('passwordPolicy.maxPIN'), value: data.numAttemptsAuthLock },
          { text: this.translateService.instant('passwordPolicy.timeTotalPIN'), value: data.quantityTimeAuthAttempts },
          { text: this.translateService.instant('passwordPolicy.timePIN'), value: data.quantityLockoutTime },
          { text: this.translateService.instant('passwordPolicy.number'), value: data.numFailedAttemps },
          { text: this.translateService.instant('passwordPolicy.time'), value: data.quantityTimeFailedAttempts },
          { text: this.translateService.instant('passwordPolicy.expPIN'), value: data.numExpirationDays },
          { text: this.translateService.instant('passwordPolicy.cadPIN'), value: data.quantityExpirationDays },
        ];
      },
      (error) => console.error(error)
    );
  }

  returnHome(): void {
    this.router.navigate(['/home', { keepFilter: true }]);
  }
}
